export const poolStyles = {
  forceDeleteAlert: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    bgcolor: "rgba(211, 47, 47, 0.1)",
    border: "1px solid #D32F2F",
    color: "#B71C1C",
    borderRadius: "4px",
    px: 1,
    py: 1,
    mb: 1,
  },
  shareCell: {
    minWidth: 70,
    mx: "auto",
  },
  shareBar: {
    mt: 0.5,
    height: 4,
    borderRadius: 999,
    backgroundColor: "#F1F4FA",
    overflow: "hidden",
  },
  shareBarFill: (width, color) => ({
    width: `${width}%`,
    height: "100%",
    borderRadius: 999,
    backgroundColor: color,
  }),
  chipRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  chip: {
    display: "inline-block",
    maxWidth: 110,
    px: 1,
    py: 0.25,
    border: "1px solid #D1D9EF",
    borderRadius: 999,
    backgroundColor: "#F8FAFE",
    color: "#555555",
    fontSize: 11,
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statusCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  formStats: {
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    border: "1px solid #D1D9EF",
    borderRadius: 2,
    px: 1.75,
    py: 1.25,
    mb: 2.5,
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 150px",
    gap: 2.5,
    "@media (max-width: 560px)": {
      gridTemplateColumns: "1fr",
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    mb: 2,
  },
  inputSuffix: {
    position: "relative",
    "& .common-ip": {
      paddingRight: "30px",
    },
    "& span": {
      position: "absolute",
      top: "50%",
      right: 12,
      transform: "translateY(-50%)",
      fontSize: 13,
      color: "#666666",
      pointerEvents: "none",
    },
  },
};
